import React, { useState } from 'react';

import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const AvailabilityControls = ({ onAvailabilityChange }) => {
  const [selectedTimeSlot, setSelectedTimeSlot] = useState('');
  const [selectedDays, setSelectedDays] = useState([]);

  const timeSlotOptions = [
    { value: 'morning', label: 'Morgen (06:00-14:00)' },
    { value: 'afternoon', label: 'Nachmittag (14:00-22:00)' },
    { value: 'night', label: 'Nacht (22:00-06:00)' },
    { value: 'full', label: 'Ganztags (06:00-22:00)' }
  ];

  const dayOptions = [
    { value: 'monday', label: 'Montag' },
    { value: 'tuesday', label: 'Dienstag' },
    { value: 'wednesday', label: 'Mittwoch' },
    { value: 'thursday', label: 'Donnerstag' },
    { value: 'friday', label: 'Freitag' },
    { value: 'saturday', label: 'Samstag' },
    { value: 'sunday', label: 'Sonntag' }
  ];

  const handleQuickSet = (availability) => {
    const quickSets = {
      available: { days: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'], timeSlot: 'full' },
      weekend: { days: ['saturday', 'sunday'], timeSlot: 'morning' },
      unavailable: { days: [], timeSlot: '' }
    };
    
    const setting = quickSets?.[availability];
    setSelectedDays(setting?.days);
    setSelectedTimeSlot(setting?.timeSlot);
    onAvailabilityChange(setting);
  };

  const handleApplyAvailability = () => {
    onAvailabilityChange({
      days: selectedDays,
      timeSlot: selectedTimeSlot
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <h3 className="text-sm font-medium text-foreground mb-4">Verfügbarkeit setzen</h3>
      {/* Quick Set Buttons */}
      <div className="space-y-2 mb-4">
        <Button
          variant="outline"
          size="sm"
          onClick={() => handleQuickSet('available')}
          iconName="Clock"
          iconPosition="left"
          iconSize={14}
          className="w-full justify-start"
        >
          Wochentags verfügbar
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => handleQuickSet('weekend')}
          iconName="Calendar"
          iconPosition="left"
          iconSize={14}
          className="w-full justify-start"
        >
          Wochenende verfügbar
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => handleQuickSet('unavailable')}
          iconName="X"
          iconPosition="left"
          iconSize={14}
          className="w-full justify-start text-error"
        >
          Nicht verfügbar
        </Button>
      </div>
      {/* Custom Availability */}
      <div className="space-y-3">
        <Select
          label="Zeitraum"
          options={timeSlotOptions}
          value={selectedTimeSlot}
          onChange={setSelectedTimeSlot}
          placeholder="Zeitraum wählen"
        />

        <Select
          label="Tage"
          options={dayOptions}
          value={selectedDays}
          onChange={setSelectedDays}
          multiple
          placeholder="Tage auswählen"
        />

        <Button
          variant="default"
          size="sm"
          onClick={handleApplyAvailability}
          disabled={!selectedTimeSlot || selectedDays?.length === 0}
          className="w-full"
        >
          Verfügbarkeit anwenden
        </Button>
      </div>
    </div>
  );
};

export default AvailabilityControls;